
export const routesMenu = [
    {
        id: 'home',
        icon: 'home',
        name: 'Pendências',
        translateId: 'home'
    },
    // {
    //     id: 'home',
    //     icon: 'orders',
    //     name: 'Todos Pedidos',
    //     translateId: 'myOrder'
    // },
    // {
    //     id: 'customer',
    //     icon: 'newOrder',
    //     name: 'Clientes',
    //     translateId: 'customer'

    // },
    {
        id: 'user-customer',
        icon: 'users',
        name: 'Usuários',
        translateId: 'users'

    },
    // {
    //     id: 'user-backoffice',
    //     icon: 'users',
    //     name: 'Usuários backoffice',
    //     translateId: 'usersBack'

    // },
    {
        id: 'customers',
        icon: 'customers',
        name: 'Clientes',
        translateId: 'customers'

    },
    // {
    //     id: 'config',
    //     icon: 'links',
    //     name: 'Configurações',
    //     translateId: 'config'
    // }

    {
        id: 'call-center',
        icon: 'callCenter',
        name: 'Fale conosco',
        translateId: 'callCenter.menu'
    },

    {
        id: 'configurations',
        icon: 'configurations',
        name: 'Configurations',
        translateId: 'configurations',
        children: [            
            {
                id: 'holidays-configuration',
                name: 'Holidays-configuration',
                translateId: 'holidaysConfiguration.menu'
            },

            {
                id: 'customers-survey-configuration',
                name: 'Customers-survey-configuration',
                translateId: 'customersSurveyConfiguration.menu'
            }
        ]
    },

    {
        id: 'reports',
        icon: 'reports',
        name: 'Reports',
        translateId: 'reports',
        children: [
            {
                id: 'orders',
                name: 'Orders',
                translateId: 'orders'
            },
            {
                id: 'customers-survey-report',
                name: 'Customers Survey Report',
                translateId: 'customersSurveyReport'
            },
            {
                id: 'call-center-report',
                name: 'Call Center Report',
                translateId: 'callCenter.menu'
            }
        ]
    },

    {
        id: 'links',
        icon: 'links',
        name: 'Links úteis',
        translateId: 'links'
    },
    {
        id: 'banking-account',
        icon: 'banking-account',
        name: 'Banking Account',
        translateId: 'bankingAccount'
    },
    {
        id: 'notifications',
        icon: 'notifications',
        name: 'Informativos',
        translateId: 'notificationMenu'

    },
];